var _path, _path2, _path3, _mask, _path4, _mask2, _path5, _path6, _path7, _path8, _mask3, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVehicles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M4.41 4.434c.679-.292 6.573-.315 6.573-.315h.156s5.892.023 6.57.315M6.009 12.793l-2.62-3.34c1.45-.151 7.594 0 7.594 0h.157s6.143-.151 7.593 0l-2.619 3.34"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M11.14 12.583s4.43.035 4.93.19q.023.008.044.021c.065.04.1.125.114.237.072.602-.508 2.032-.907 2.27-.49.29-4.18.448-4.18.448h-.156s-3.691-.158-4.182-.448c-.4-.238-.98-1.668-.907-2.27.014-.112.05-.195.114-.237a.2.2 0 0 1 .044-.02c.501-.154 4.93-.19 4.93-.19h.138M5.888 13.029s-2.594-.84-2.831-1.129"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M6.8 15.299s-3.148-.303-3.754-.731M11.058 18.41h-.076"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "Vehicles_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.14 18.41h-.083c-1.714-.01-4.257-.35-4.257-.35l.253-1.163 3.929.3h.156l3.929-.3.253 1.163s-2.542.34-4.256.35"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.14 19.41a1 1 0 1 0 0-2zm-.083-1-.006 1h.006zM6.8 18.06l-.977-.212a1 1 0 0 0 .845 1.204zm.253-1.163.076-.997a1 1 0 0 0-1.053.784zm3.929.3-.077.997q.038.003.077.003zm.156 0v1q.039 0 .076-.003zm3.929-.3.977-.213a1 1 0 0 0-1.053-.784zm.253 1.163.132.992a1 1 0 0 0 .845-1.204zm-4.262-.65a1 1 0 0 0 .012 2zm.082 0h-.083v2h.083zm-.077 0c-.807-.005-1.833-.088-2.676-.174a57 57 0 0 1-1.429-.163l-.02-.003h-.006l-.132.99-.132.992h.008l.023.004.087.011a53 53 0 0 0 1.399.16c.857.086 1.96.178 2.866.183zm-3.286.863.253-1.164-1.954-.425-.253 1.164zm-.8-.38 3.928.301.153-1.994-3.929-.3zm4.005.304h.156v-2h-.156zm.232-.003 3.929-.3-.152-1.994-3.93.3zm2.876-1.085.253 1.164 1.954-.425-.253-1.164zm1.23.951-.132-.99h-.006l-.02.003-.081.01q-.108.014-.305.038c-.26.031-.625.073-1.042.115-.843.086-1.868.17-2.676.174l.012 2c.906-.005 2.009-.097 2.866-.184a58 58 0 0 0 1.398-.16l.087-.01.023-.003.006-.001h.002z",
  mask: "url(#Vehicles_svg__a)"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "Vehicles_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.688 16.397h.001l2.625.198-.39 1.526-2.052-.172"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M2.688 15.397a1 1 0 1 0 0 2zm.001 1 .076-.997-.076-.003zm2.625.198.968.248a1 1 0 0 0-.893-1.245zm-.39 1.526-.084.997a1 1 0 0 0 1.052-.75zm-1.968-1.169a1 1 0 1 0-.168 1.993zm-.268.445h.001v-2h-.002zm-.074-.003 2.624.199.151-1.995-2.624-.198zm1.73-1.046-.39 1.525 1.938.496.39-1.526zm.663.777-2.051-.173-.168 1.993 2.052.173z",
  mask: "url(#Vehicles_svg__b)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "m3.547 8.628-1.125.05.007-1.316h-.684a.734.734 0 0 0-.734.703c-.025.571-.02 1.326.153 1.591.29.448 2.137.318 2.137.318M2.872 17.948c-.006.042-.403 3.6.305 3.73h.957c.39 0 .705-.317.705-.705v-1.667"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M10.983 1.219s4.111.132 5.008.21c0 0 .793-.356 1.72 3.005.282 1.02.575 2.378.864 4.194a28 28 0 0 0 .248 1.347c.087.552.18 1.225.244 1.926.08.91.109 1.867.009 2.669 0 0 .474 1.073.421 1.31a8 8 0 0 0-.063.518c-.047.434-.112 1.053-.184 1.552-.055.381-.115.694-.174.803-.083.155-.693.364-1.793.543-1.34.218-3.409.396-6.142.38h-.156c-2.736.014-4.803-.162-6.142-.38-1.102-.18-1.71-.388-1.795-.543-.06-.11-.12-.422-.174-.803-.072-.501-.137-1.12-.185-1.552a9 9 0 0 0-.063-.517c-.053-.238.422-1.312.422-1.312-.1-.8-.07-1.757.01-2.668a28 28 0 0 1 .333-2.448c.09-.507.158-.825.158-.825.288-1.816.582-3.174.863-4.194.928-3.36 1.721-3.004 1.721-3.004.895-.08 4.85-.211 4.85-.211"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "M16.233 13.029s2.595-.84 2.832-1.129M15.32 15.299s3.148-.303 3.754-.731"
})), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
  id: "Vehicles_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.432 16.397-2.624.198.39 1.526 2.051-.172"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M19.508 17.394a1 1 0 0 0-.151-1.994zm-2.7-.799-.076-.997a1 1 0 0 0-.893 1.245zm.39 1.526-.969.248a1 1 0 0 0 1.053.749zm2.135.824a1 1 0 0 0-.167-1.993zm.024-3.545-2.625.198.151 1.995 2.625-.2zm-3.518 1.443.39 1.526 1.938-.496-.39-1.525zm1.443 2.275 2.05-.173-.166-1.993-2.052.173z",
  mask: "url(#Vehicles_svg__c)"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: "m18.575 8.628 1.127.05-.007-1.316h.684c.393 0 .719.31.734.703.025.571.02 1.326-.152 1.591-.29.448-2.138.318-2.138.318M19.25 17.948s.405 3.598-.307 3.73h-.956a.705.705 0 0 1-.705-.705v-1.667"
})));
export default SvgVehicles;